import {INCOMING_ACTION, OUTGOING_ACTION, snippetService} from '../services/snippet.service';
import {saveToStore, StorePath, storeSaveAction, useStoreActionsFromStore} from '../services/store.service';
import {PickupLine, TrackData, VIEW_MODE} from '../models/snippet-payload.model';
import {useEffect} from 'react';
import {useNavigate} from 'react-router';
import {ROUTES} from '../models/routes.const';
import {logger} from '../services/utils.service';
import {themeService} from '../services/theme.service';
import {orbeeJdPowerService} from '../services/third-party/orbee-jd-power.service';
import {debugService} from '../services/debug.service';

const DataSetup = () => {
	const storeAction = useStoreActionsFromStore(storeSaveAction);
	const navigate = useNavigate();

	useEffect(() => {
		snippetService.subscribe(INCOMING_ACTION.TRACK_DATA, (data: unknown) => {
			const {payload: {response, params}} = data as TrackData;
			debugService.enableFromTrack(params, response);
			logger('FullpathGpt got message INCOMING_ACTIONS.TRACK_DATA: ', data);
			saveToStore(storeAction, StorePath.TRACK_DATA, response);
			saveToStore(storeAction, StorePath.TRACK_PARAMS, params);
			saveToStore(storeAction, StorePath.DEALER_INFO, params.dealer_info);
			saveToStore(storeAction, StorePath.SETTINGS, response?.chat_settings);
			saveToStore(storeAction, StorePath.IS_DEBUG_MODE, debugService.isDebugMode());
			eagerLoadServices(params, response);
		});

		snippetService.subscribe(INCOMING_ACTION.SHOW_HOME, () => {
			logger('FullpathGpt got message INCOMING_ACTIONS.SHOW_HOME');
			snippetService.sendMessage({action: OUTGOING_ACTION.RESIZE});
			snippetService.sendMessage({
				action: OUTGOING_ACTION.VIEW_MODE_UPDATE,
				payload: {viewMode: VIEW_MODE.WIDGET},
			});
			navigate(ROUTES.CHAT);
		});

		snippetService.subscribe(INCOMING_ACTION.SHOW_PICKUP_LINE, (data: unknown) => {
			const {payload: {pickup_line}} = data as PickupLine;
			logger('FullpathGpt got message INCOMING_ACTIONS.SHOW_PICKUP_LINE: ', data);
			if (pickup_line) {
				saveToStore(storeAction, StorePath.PICKUP_LINE, pickup_line);
				snippetService.sendMessage({
					action: OUTGOING_ACTION.VIEW_MODE_UPDATE,
					payload: {viewMode: VIEW_MODE.NOTIFICATION},
				});
				navigate(ROUTES.NOTIFICATION);
			}
		});

		snippetService.sendMessage({action: OUTGOING_ACTION.FPC_READY});

		// if (isLocalhost()) {
		// 	saveToStore(storeAction, StorePath.MESSAGES, MOCK_MESSAGES);
		// }
	}, []);

	const eagerLoadServices = (params: Record<string, any>, response: Record<string, any>): void =>{
		themeService.init(params.primary_color, params.accent_color, response.oems);
		orbeeJdPowerService.init(response.oems, params.url);
	};

	return <></>;
};

export default DataSetup;
